@for (ladder of notification.token.boostLadder; track ladder) {
    <vn-icon
        name="theme-check"
        size="12"
        class="acca-boost-leg-circle"
        [ngClass]="{
            'acca-boost-leg-circle-selected': pickCount >= ladder.numberOfLegs,
        }" />
    <div class="acca-boost-leg">
        {{ ladder.ratio | msAccaBoostRatio: false : sitecore.accaBoost.ForInfo | msInterpolate: { numberOfPicks: ladder.numberOfLegs } }}
    </div>
}
